import React, { useLayoutEffect } from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
// @ts-ignore
import styles from './ContextMenu.module.scss';

interface ContextMenuProps {
	params: any;
	children?: React.ReactChild | React.ReactChild[];
	onContextClose: () => void;
	openInModalRoot?: boolean;
	customRootName?: string;
}

export interface ContextMenuParams {
	isOpen: boolean;
	clientX?: number;
	clientY?: number;
}

export default function ContextMenu(props: ContextMenuProps) {
	const {
		children,
		params,
		onContextClose,
		openInModalRoot = false,
		customRootName,
	} = props;
	const [position, setPosition] = useState<object>({ left: 0, top: 0 });

	const handleCloseContext = () => {
		onContextClose?.();
	};

	useEffect(() => {
		const close = (e: any) => {
			if (e.keyCode === 27) {
				handleCloseContext();
			}
		};
		window.addEventListener('keydown', close);
		return () => window.removeEventListener('keydown', close);
	}, []);

	useLayoutEffect(() => {
		const contextMenuHeight =
			document.getElementById('contextmenu')?.clientHeight;
		const contextMenuWidth =
			document.getElementById('contextmenu')?.clientWidth;
		const positionX = params?.clientX;
		const positionY = params?.clientY;
		const borderDifferenceX = window.innerWidth - positionX;
		const borderDifferenceY = window.innerHeight - positionY;

		setPosition(prevValue => {
			return {
				...prevValue,
				top: positionY,
				left: positionX,
				right: 'auto',
				bottom: 'auto',
			};
		});

		if (borderDifferenceX && contextMenuWidth) {
			if (borderDifferenceX < contextMenuWidth) {
				setPosition(prevValue => {
					return {
						...prevValue,
						right: borderDifferenceX,
						left: 'auto',
					};
				});
			}
		}

		if (borderDifferenceY && contextMenuHeight) {
			if (borderDifferenceY < contextMenuHeight) {
				setPosition(prevValue => {
					return {
						...prevValue,
						bottom: borderDifferenceY,
						top: 'auto',
					};
				});
			}
		}
	}, [params]);

	const content = params?.isOpen && (
		<>
			<div className={styles.backdrop} onClick={() => handleCloseContext()} />
			<div id='contextmenu' className={styles.wrapper} style={position}>
				{React.Children.map(children, child => {
					return <div className={styles.child}>{child}</div>;
				})}
			</div>
		</>
	);

	if (openInModalRoot) {
		// @ts-ignore
		const modalRoot = document.getElementById(customRootName ?? 'popup-root');
		return ReactDOM.createPortal(content, modalRoot);
	} else {
		return content;
	}
}
